import { useMemo } from 'react';

import { ApplianceModel, FilterOption } from '@common/models';
import {
    filterAllEntries,
    getSelectedFiltersMap,
    initializeFiltersOptions,
} from '@core/components/filters/filterUtils';
import { useAppSelector } from '@redux/hooks';
import { SinkFilters, selectSinkFilters } from '@redux/slices/sinkSlice';

import useSink from './useSink';

type useFilteredSinksReturn = {
    filteredSinks: ApplianceModel[];
    sinkFilters: SinkFilters;
};

// TODO: consolidte with useFilteredDishwashers
const useFilteredSinks = (): useFilteredSinksReturn => {
    const { browsedSinks } = useSink();
    const _sinkFilters = useAppSelector(selectSinkFilters);

    const initialFilterOptions: SinkFilters = useMemo(() => {
        let initialFilters: SinkFilters = {};
        const setSinkFilters = (val: SinkFilters) => {
            initialFilters = val;
        };
        if (browsedSinks.length > 0) {
            initializeFiltersOptions(browsedSinks, setSinkFilters);
        }
        return initialFilters;
    }, [browsedSinks]);

    const sinkFilters = useMemo(() => {
        return _sinkFilters ?? initialFilterOptions;
    }, [_sinkFilters, initialFilterOptions]);

    const filteredSinks = useMemo(() => {
        const selectedFilters: Map<string, FilterOption[]> = getSelectedFiltersMap(sinkFilters);
        return filterAllEntries(Array.from(selectedFilters.entries()), browsedSinks);
    }, [sinkFilters, browsedSinks]);

    return {
        filteredSinks,
        sinkFilters,
    };
};

export default useFilteredSinks;
